import { render, staticRenderFns } from "./liveItem.vue?vue&type=template&id=6e229ed8&"
import script from "./liveItem.vue?vue&type=script&lang=js&"
export * from "./liveItem.vue?vue&type=script&lang=js&"
import style0 from "./liveItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports